import { render, staticRenderFns } from "./KitchenDisplayLayout.vue?vue&type=template&id=6023d440&scoped=true&"
import script from "./KitchenDisplayLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./KitchenDisplayLayout.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./KitchenDisplayLayout.vue?vue&type=style&index=0&id=6023d440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023d440",
  null
  
)

export default component.exports